import StatusComponent from '@/components/Status/Status.vue';
import StepsSummaryComponent from '@/components/StepsSummary/StepsSummary.vue';
import { LINK } from '@/links';
import { TEXT_MODAL_TITLE, TEXT_MODAL_STEPS } from './texts';

const months = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
  'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export default {
  name: 'ModalComponent',
  props: ['applicationData', 'show', 'close'],
  components: {
    StatusComponent,
    StepsSummaryComponent,
  },
  data() {
    return {
      stepsQuantity: this.$props.applicationData.requestSteps.length,
      modalTitleText: TEXT_MODAL_TITLE,
      modalText: TEXT_MODAL_STEPS,
      stepsTitles: [],
      subtitlesSteps: [],
      currentStep: 0,
      showSteps: false,
      showStepsSummary: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.applicationData.requestSteps.forEach((step) => {
        if (step.stepPassed) {
          this.currentStep += 1;
        }
        const hidePeriod = step.stepName === 'SavingsComing' && step.stepPassed;
        const stepPeriod = hidePeriod ? '' : this.getDate(step.startDate, step.endDate);
        this.subtitlesSteps.push(stepPeriod);
        this.stepsTitles.push(this.getTitles(step.stepName));
      });

      this.showSteps = true;
      this.showStepsSummary = true;
    },
    getTitles(nameStep) {
      switch (nameStep) {
        case 'TransferRequestAccepted':
          return 'Tu solicitud ha sido aceptada';
        case 'SavingsComing': {
          const savingsComing = this.currentStep < 2 ? 'vendrán' : 'vienen';
          return `Tus ahorros ${savingsComing} en camino`;
        }
        case 'SavingsArrived':
          return 'Llegarán tus ahorros';
        default:
          return '';
      }
    },
    getDate(strStartDate, strEndDate) {
      const startDate = new Date(strStartDate);

      if (strEndDate == null) {
        return `${startDate.getDate()} de ${months[startDate.getMonth()]}`;
      }

      const endDate = new Date(strEndDate);
      return `(Entre el ${startDate.getDate()} de ${months[startDate.getMonth()]} y ${endDate.getDate()} de ${months[endDate.getMonth()]})`;
    },
    goToCuprum() {
      window.location.href = LINK.GO_TO_CUPRUM;
    },
    goToPasswordReset() {
      window.location.href = LINK.PASSWORD_RECOVERY;
    },
  },
};
